<template>
  <div class="product-service-section-container" v-if="dataList.length>0">
      <section-title :text="title" :btn="{text:'浏览全部案例',center:true,router:'https://jzt.jd.com/static/yxy-jqsz/5'}"/>
      <div class="section-main">
        <span class="item-menu" v-for="(da,index) in dataList" :key="index" @click="changeTab(index)" :class="active==index?'active':''">
          {{ da.tabName }}
        </span>    
      </div>
      <div class="cls-main">
				<j-carousel
                    :height="446" :autoplay="true" :loop="true" :autoplay-speed="2700" arrow="never" :indicatorStyle="{left: '110px', bottom: '-15px'}" subActiveColor="#3247FF">
                    <j-carousel-item v-for="(item, index) in dataList[active].child"
                    :key="index">
                        <div class="carousel-item-wrap">
                            <img :src="item.img" width="1203" height="446"/>
                            <div class="introduce-block">
                                <div class="introduce-block-title" >{{ item.title }}</div>
                                <div class="introduce-block-content">
                                  <div><b class="introduce-block-content-b">{{ item.contentTitle }}</b>{{ item.contentMess }}</div>
                                  <b class="introduce-block-array">{{ item.CTitle }}</b>
                                  <div v-for="(cit, index) in item.CArray" :key="index">{{ cit }}</div>
                                </div>
                                <div class="introduce-block-footer">
                                    <div v-for="(up, index) in (item.footer || [])"
                                        :key="index"
                                        class="flex-center"
                                        :class="{'ml30': index != 0}"
                                    >
                                        <div>
                                            <div style="font-size: 14px; font-weight: 500">{{ up.key }}</div>
                                            <div style="white-space: nowrap;">
                                                <span style="font-size: 40px; font-family: Bebas;">{{ up.value }}</span>
                                            </div>
                                        </div>
                                            <img src="//storage.360buyimg.com/ui2code/preview/excellentCaseUpIcon.png" class="ml8" width="40"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </j-carousel-item>
              </j-carousel>
			</div>
       
  </div>
</template>

<script>
import sectionTitle from "../../components/sectionTitle.vue";
export default {
name: "partner",
components: {
  sectionTitle: sectionTitle
},
props: {
  title: {
    type: String,
    default: ""
  },
  mess: {
    type: String,
    default: ""
  }
},
data() {
  return {
    active:0,
    dataList:[
        {
          tabName:'经营增长',
          tabMess:'南讯×TOM FORD：短信营销助力域内精准拉新获客',
          img:'//img10.360buyimg.com/img/jfs/t1/239102/13/24860/12375/673da35aF2e877eaa/d0c5a815c458d612.png',
          child:[
            {
              img: '//img10.360buyimg.com/img/jfs/t1/109474/36/56042/382609/67468f8eF6f2366be/4d58671c69ff155f.png',
              title: '南讯×TOM FORD：短信营销助力域内精准拉新获客',
              contentTitle: '品牌诉求:',
              contentMess:'拓展新用户并提升销量',
              CTitle:'解决方案：',
              CArray:['1）投前：数据洞察用户心智，锚定目标人群；','2）投中：借ECRM、智推等消息产品，公域触达跨类目、同类目人群及历史大促人群，多方位获客；','3）投后：全链路效果复盘，持续优化人群策略。'],
              footer: [
                {
                  key: '24年H2GMV',
                  value: '70%+'
                },
                {
                  key: '24年带动GMV',
                  value: '百万+'
                }
              ]
            },
            {
              img: '//img10.360buyimg.com/img/jfs/t1/107367/10/58707/515858/67468ff9F98c32344/3fd712a3f5e1799d.png',
              title: '印橙×康师傅：数智赋能，驱动品牌年轻用户增长',
              contentTitle: '品牌诉求:',
              contentMess:'促进品牌年轻消费者持续增长',
              CTitle:'解决方案：',
              CArray:['1）用数坊，从行业、行业品牌、自身等维度解构年轻用户特征及偏好；','2）机会用户分层，锚定拉新场景；','3）人货场匹配，营销方略&京准通全域触达。'],
              footer: [
                {
                  key: '购买用户',
                  value: '23%'
                },
                {
                  key: '新客率',
                  value: '84%'
                }
              ]
            }
          ]
        },
        {
          tabName:'用户增长',
          tabMess:'通过全域用户识别、打通与精细运营，实现全域用户增长。',
          img:'//img10.360buyimg.com/img/jfs/t1/239102/13/24860/12375/673da35aF2e877eaa/d0c5a815c458d612.png',
          child:[
            {
              img: '//img10.360buyimg.com/img/jfs/t1/147939/9/48855/51034/67468f6eFc6471a64/a6a14886950d2b99.png',
              title: '电通×博世：京东营销云助力人群破圈',
              contentTitle: '品牌诉求:',
              contentMess:'激活数据价值，实现人群破圈增长',
              CTitle:'解决方案：',
              CArray:['1）品牌数据上传，联动京东域数据洞察品牌人群特征及在京东的跨类目分布；','2）营销云策略引擎识别用户品牌兴趣度，以分层用户、精细匹配权益；并判别不同权益的转化率，优化推送策略。'],
              footer: [
                {
                  key: 'CTR',
                  value: '183%+'
                },
                {
                  key: 'CPM',
                  value: '24%'
                }
              ]
            },
            {
              img: '//img10.360buyimg.com/img/jfs/t1/188722/37/53370/210708/674690a4F0814d2b8/8ff671500630108a.png',
              title: '悠易科技×飞鹤：构建可持续性增长模型，数智驱动用户增长',
              contentTitle: '品牌诉求:',
              contentMess:'提高电商渠道的人群拉新转化',
              CTitle:'解决方案：',
              CArray:['1）面向浏览、搜索、线下行为的全域母婴人群，设定高匹配度媒体；','2）A0、A1用户分层，复盘细分人群覆盖、验证投放策略；','3）序列化投放，挖掘高潜转化用户，提升流转。'],
              footer: [
                {
                  key: '5A人群资产',
                  value: '75%'
                },
                {
                  key: 'CTR完成率',
                  value: '130%'
                }
              ]
            }
          ]
        },
        {
          tabName:'营销提效',
          tabMess:'通过数据能力，助力品牌在硬广投放、内容营销等场景进行站内外流量联动，实现营销提效。',
          img:'//img10.360buyimg.com/img/jfs/t1/239102/13/24860/12375/673da35aF2e877eaa/d0c5a815c458d612.png',
          child:[
            {
              img: '//img10.360buyimg.com/img/jfs/t1/149120/18/50278/132295/67468f6cF3fa350fe/9fef04eb398921ee.png',
              title: '思源瀚海×海信：KOL跨域联动，助推新品全域打爆',
              contentTitle: '品牌诉求:',
              contentMess:'推动市占率增长',
              CTitle:'解决方案：',
              CArray:['1）抓取小红书、抖音回流人群，营销云策略引擎识别京东用户及种草人群特征，输出人群扩量投放策略；','2）构建效果评估模型，阶段性投中监控，沉淀策略模型持续运行。'],
              footer: [
                {
                  key: '市占率',
                  value: '11%'
                },
                {
                  key: 'ROI',
                  value: '107%'
                }
              ]
            },
            {
              img: '//img10.360buyimg.com/img/jfs/t1/241300/9/17224/440507/674690eeF9b727c97/4f4868dcbd9c2370.png',
              title: '群邑×Swisse：细分用户偏好，营销云分场景精准转化助增长',
              contentTitle: '品牌诉求:',
              contentMess:'加投重点类目，促进拉新转化',
              CTitle:'解决方案：',
              CArray:['1）外媒策略：外媒投放数据回流至京东营销云，通过全链路效果分析，反哺投放策略优化；','2）直投策略：洞察外投人群兴趣特征，区分来源媒体及意向类目，通过京准通站外直投定向触达目标人群。'],
              footer: [
                {
                  key: '类目转化率',
                  value: '1XX%'
                },
                {
                  key: '类目ROI',
                  value: '5X%'
                }
              ]
            }
          ]
        },
        {
          tabName:'新品创新',
          tabMess:'通过大小数据消费者洞察能力，联合行业伙伴为品牌提供一站式新品创新解决方案，缩短新品到爆品的路径。',
          img:'//img10.360buyimg.com/img/jfs/t1/239102/13/24860/12375/673da35aF2e877eaa/d0c5a815c458d612.png',
          child:[
            {
              img: '//img10.360buyimg.com/img/jfs/t1/247537/37/26277/339857/67469109Fdfe162e1/10fd8b59b78d62a9.png',
              title: '联蔚×摩得罗：数智赋能人群定位及视觉测试，新品上市打爆',
              contentTitle: '品牌诉求:',
              contentMess:'新海外品牌寻找高效本土化沟通策略',
              CTitle:'解决方案：',
              CArray:['1）找人群：数坊精准定位品牌TA，并进一步挖掘啤酒类目潜力人群；','2）定视觉及沟通：京洞察-京优选PK高效精准，帮助品牌优选视觉与文案。'],
              footer: [
                {
                  key: '人群资产累积',
                  value: '3,000Mil+'
                }
              ]
            },
            {
              img: '//img10.360buyimg.com/img/jfs/t1/225105/34/36979/175838/676112ddFff40dafb/b4abd2e2873b933d.png',
              title: '华美互通×雀巢：京洞察助力真视高新品起量和市场突破',
              contentTitle: '品牌诉求:',
              contentMess:'获取新客并沉淀长期运营人群，提升销量',
              CTitle:'解决方案：',
              CArray:['1）沟通策略：数坊洞察圈定TA，京洞察调研用户产品需求、购买意愿、关注卖点等，指导沟通策略；','2）新品培育：站内测试，优化投放组合；站外大促前高强度蓄水，回流数据站内再营销，完成销售增长。'],
              footer: [
                {
                  key: 'GMV',
                  value: '526%'
                },
                {
                  key: '新客',
                  value: '73%'
                }
              ]
            }
          ]
        },
      ]
  }
},
methods:{
  changeTab(idx){
      this.active = idx
  }
}
};
</script>

<style lang="scss" scoped>
/deep/ .jad-carousel-indicator .jad-carousel-indicator-item{
    width: 110px !important;
    height: 11px !important;
    background: #D2D2D2;
    opacity: 1;
}
.product-service-section-container {
  width: 100%;
  padding: 80px 0 133px;
  background: linear-gradient(180deg, rgba(240, 242, 255, 1) 0%, rgba(251, 252, 255, 1) 48.13%, rgba(255, 255, 255, 1) 100%);

  .section-main {
    width: 1268px;
    margin: 28px auto 0;
    display: flex;
    justify-content: center;
    .item-menu {
      width: 301.41px;
      height: 87px;
      display:inline-block;
      box-sizing: border-box;
      background: rgba(255, 255, 255, 0.5);
      box-shadow: 0px 1px 10px 5px #FFFFFF inset;
      color:#6F6FFF;
      text-align: center;
      line-height:87px;
      cursor:pointer;
      font-size: 24px;
    }
    .item-menu:first-child {
      border-radius: 12px 0px 0px 12px;
    }
    .item-menu:last-child {
      border-radius: 0px 12px 12px 0px;
    }
    .item-menu:hover {
      background: linear-gradient(360deg, rgba(49, 71, 255, 1) 0%, rgba(72, 142, 255, 1) 100%);
      box-shadow: 0px 1px 6px rgba(255, 255, 255, 0.6) inset;
      color:#fff;
    }
    .item-menu.active {
      background: linear-gradient(360deg, rgba(49, 71, 255, 1) 0%, rgba(72, 142, 255, 1) 100%);
      box-shadow: 0px 1px 6px rgba(255, 255, 255, 0.6) inset;
      color:#fff;
    }
  }
  .cls-main {
      margin: 0 auto;
      width: 1203px;
      margin-top: 77px;
    }
    .jad-carousel {
        overflow: hidden;
        .jad-carousel-item {
            background-color: white;
        }
        .carousel-item-wrap {
            position: relative;
            .flex-center {
                display: flex;
                align-items: center;
            }
            .ml8 {
                margin-left: 8px;
            }
            .ml30 {
                margin-left:50px;
            }
            .introduce-block {
                position: absolute;
                top: 94px;
                right: 22px;
                color: white;
                width: 340px;
                text-align: left;
                &-title {
                    font-size: 24px;
                    font-weight: 500;
                    color: rgba(255,255,255,1);
                }
                &-content {
                    margin-top: 16px;
                    font-size: 14px;
                    font-weight: normal;
                    color: rgba(255,255,255,1);
                    text-align: justify;
                    &-b {
                      margin-right: 5px;
                  }
                }
                &-array{
                  display: block;
                  margin-top: 5px;
                }
                &-footer {
                    margin-top: 32px;
                    display: flex;

                }
            }
        }
    }

}
</style>

